/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use client'

import { createContext, type ReactNode, useContext } from 'react'

const SideNavCookieContext = createContext<Record<string, boolean>>({})

export type SideNavCookieProviderProps = {
  cookies: Record<string, boolean>
  children: ReactNode
}

export function SideNavCookieProvider({ cookies, children }: SideNavCookieProviderProps) {
  return <SideNavCookieContext.Provider value={cookies}>{children}</SideNavCookieContext.Provider>
}

export const useSideNavSsrCookies = (): Record<string, boolean> => useContext(SideNavCookieContext)
